<style lang='less' scoped>
.sz-card-layout {
   overflow: auto;
   display: flex;
   &__side {
      overflow-y: auto;
   }
   &__main {
      overflow: auto;
      flex: 1;
   }
   .side-border {
      border-right: 1px solid #eaecf2;
   }
}
</style>
<template>
   <div class="sz-card-layout" :style="{ height: height }">
      <div
         class="sz-card-layout__side"
         :class="[leftSideBorder ? 'side-border' : false]"
         :style="{ width: leftSideWidth }"
      >
         <slot name="leftSide" />
      </div>
      <div class="sz-card-layout__main">
         <slot />
      </div>
   </div>
</template>

<script>
import { defineComponent } from "vue";

export default defineComponent({
   props: {
      /**
       * 窗口高度
       */
      height: {
         type: String,
         default: "calc(100% - 42px - 24px)",
      },

      /**
       * 左侧宽度
       */
      leftSideWidth: {
         type: String,
         default: "280px",
      },

      /**
       * 是否有边框
       */
      leftSideBorder: {
         type: Boolean,
         default: true,
      },
   },
   data() {
      return {};
   },
});
</script>
